
<template>
  <div class="home shrink-text">
    <NavBar />
    <div v-if="candidates && !currentCandidateSelected" class="d-flex justify-content-center p-5">
      <div class="col-lg-6 col-md-8 col-sm-10">
        <CandidateInfoTable 
          :candidates-details="candidates"
          @candidate-selected="getCandidateInfo" 
        />   
      </div>
    </div>
    <div v-if="currentCandidateSelected && !currentAssessmentSelected" class="d-flex justify-content-center">
      <div class="row">
        <CandidateDetailsPane 
          :candidate-id="currentCandidateSelected" 
          @back-button-pressed="closeCandidatePane" 
          @assessment-returned="handleCandidateAssessmentSelect" 
          ref="detailsPane" 
        />
      </div>
    </div>
    <div v-if="currentAssessmentSelected && currentCandidateSelected && currentAssessmentSelected.assessmentDetails.results[0].assessmentQuestion" class="d-flex justify-content-center">
      <div class="row">
        <CandidateAssessmentDetailsPane 
          :assessment-selected="currentAssessmentSelected" 
          :candidate-selected="currentCandidateSelected"
          @back-button-pressed="closeAssessmentDetailsPane" 
        />
      </div>
    </div>
    <div v-if="currentAssessmentSelected && !currentAssessmentSelected.assessmentDetails.results[0].assessmentQuestion" class="d-flex justify-content-center">
    <!-- TODO: This needs to be condensed into it's own component -->
      <div style="background-color: #181a1b; color: white; padding: 20px; margin-top: 10px; border-radius: 10px;">
        <div style="float: left;">
            <button class="btn btn-link text-white" @click="handleBackButtonPress">
                <i class="fas fa-arrow-left"></i>
            </button>
        </div>
        <div style="margin-bottom:20px;">
            <h3><i class="fa-solid fa-user"></i> {{ currentCandidateSelected["firstname"] }} {{ currentCandidateSelected["lastname"] }}</h3>
            <h4> Legacy Assessment: {{ currentAssessmentSelected.assessmentDetails.assessmentName }} </h4>
            <p>The score refers to an assessment that is no longer supported.</p>
        </div>
        <table class="dark-table">
                <tbody>
                    <td><i class="fa-solid fa-clipboard"></i> {{ currentAssessmentSelected.assessmentDetails.totalQuestions }} Questions</td>
                    <td><i class="fa-solid fa-pencil"></i> Score: {{ (currentAssessmentSelected.assessmentDetails.correct/currentAssessmentSelected.assessmentDetails.totalQuestions) * 100 }}%</td>
                    <td><i class="fa-solid fa-check"></i> Status: {{ currentAssessmentSelected.assessmentDetails.status }} </td>
                    <td><i class="fa-solid fa-stopwatch"></i> Duration: {{ currentAssessmentSelected.assessmentDetails.durationFormatted }}</td>
                    <td><i class="fa-solid fa-calendar-days"></i> Date Taken: {{ currentAssessmentSelected.assessmentDateFormatted }}</td>
                </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import { getCookie, deleteAllCookies } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';
import CandidateInfoTable from '@/components/CandidateComponents/CandidateInfoTable.vue';
import CandidateDetailsPane from '@/components/CandidateComponents/CandidateDetailsPane.vue';
import CandidateAssessmentDetailsPane from '@/components/CandidateComponents/CandidateAssessmentDetailsPane.vue';

export default {
  name: 'CandidatesView',
  components: {
      NavBar,
      CandidateInfoTable,
      CandidateDetailsPane,
      CandidateAssessmentDetailsPane
  },
  data() {
    return {
        candidates: [],
        currentCandidateSelected: null,
        currentAssessmentSelected: null
    }
  },
  created() {
    this.grabCandidatesForUser();
  },
  methods: {
    closeCandidatePane() {
      this.currentCandidateSelected = null;
    },
    closeAssessmentDetailsPane() {
      this.currentAssessmentSelected = null;
    },
    getCandidateInfo(candidate) {
      this.currentCandidateSelected = candidate;
      console.log('candidateId: ' + this.currentCandidateSelected["candidateId"]);

      this.$nextTick(() => {
        this.$refs.detailsPane.fetchCandidateAssessments();
      });
    },
    async grabCandidatesForUser() {
        try {
            const userid = getCookie('userid');
            const token = getCookie('token');
            const response = await fetch(endpoint + '/api/User/GetCandidatesByUserId/' + userid, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }});

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.candidates = data.candidates;
            console.log(this.candidates);
            
        } catch(exception) { 
          deleteAllCookies();
          console.log(exception);
        }
    },
    handleCandidateAssessmentSelect(assessment) {
      this.currentAssessmentSelected = assessment;
      console.log(this.currentAssessmentSelected);
    },
    handleBackButtonPress() {
      this.currentAssessmentSelected=null;
    }
  }
}
</script>
<style scoped>
.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/home-background.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    
}
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}
</style>